import React from 'react';

const StoreAddress = () => {
  return (
    <div 
      className="store-address" 
      itemScope 
      itemType="http://schema.org/Restaurant"
    >
      <h2>Store Address</h2>
      <p itemProp="name">The Burger Barn</p>
      <div 
        itemProp="address" 
        itemScope 
        itemType="http://schema.org/PostalAddress"
      >
        <p>
          <span itemProp="streetAddress">28 N Bear Lake Blvd</span><br />
          <span itemProp="addressLocality">Garden City</span>,&nbsp;
          <span itemProp="addressRegion">UT</span>&nbsp;
          <span itemProp="postalCode">84028</span>
        </p>
      </div>
      <div className="additional-schema" style={{display: 'none'}}>
        <meta itemProp="telephone" content="+14352883693" />
        <meta itemProp="email" content="burgerbarnbearlake@gmail.com" />
        <meta itemProp="servesCuisine" content="American, Burgers, Fast Food" />
        <meta itemProp="priceRange" content="$$" />
        <meta itemProp="url" content="https://burgerbarnbearlake.com" />
        <div itemProp="geo" itemScope itemType="http://schema.org/GeoCoordinates">
          <meta itemProp="latitude" content="41.9469" />
          <meta itemProp="longitude" content="-111.3969" />
        </div>
        <div itemProp="openingHoursSpecification" itemScope itemType="http://schema.org/OpeningHoursSpecification">
          <meta itemProp="dayOfWeek" content="Monday Tuesday Wednesday Thursday" />
          <meta itemProp="opens" content="10:00" />
          <meta itemProp="closes" content="21:00" />
        </div>
        <div itemProp="openingHoursSpecification" itemScope itemType="http://schema.org/OpeningHoursSpecification">
          <meta itemProp="dayOfWeek" content="Friday Saturday" />
          <meta itemProp="opens" content="10:00" />
          <meta itemProp="closes" content="22:00" />
        </div>
        <div itemProp="openingHoursSpecification" itemScope itemType="http://schema.org/OpeningHoursSpecification">
          <meta itemProp="dayOfWeek" content="Sunday" />
          <meta itemProp="opens" content="00:00" />
          <meta itemProp="closes" content="00:00" />
        </div>
      </div>
    </div>
  );
};

export default StoreAddress;